// extracted by mini-css-extract-plugin
export var buttons = "_42-0";
export var buttonsActive = "_42-h";
export var cancelConfirm = "_42-1";
export var closeButton = "_42-2";
export var column = "_42-3";
export var container = "_42-4";
export var detailHeader = "_42-6";
export var detailTitle = "_42-7";
export var detailsContent = "_42-5";
export var header = "_42-8";
export var headerWithClose = "_42-9";
export var icon = "_42-a";
export var infoIcon = "_42-c";
export var informationContainer = "_42-b";
export var sideDrawer = "_42-d";
export var sideDrawerOpen = "_42-e";
export var stickyFooter = "_42-f";
export var typeOption = "_42-g";